import styled from "@emotion/styled";
import {Tag, Typography} from "@kaltura/ds-react-components";
import Truncate from "@mediaspace/shared/ui/truncate/Truncate";
import {generalHtmlStyles} from "@mediaspace/shared/ui/GeneralHtmlStyles";
import { systemWidth } from "@mediaspace/shared/styled";


export const StyledChannelHeader = styled("div")({
    boxShadow: "inset 0 0 0 300px rgba(0, 0, 0, 0.4)",
});

export const StyledChannelHeaderWrapper = styled("div", {
    shouldForwardProp(propName) {
        return propName !== "isKaf";
    },
})<{ isKaf?: boolean }>(({ theme, isKaf }) => [
    {
        height: isKaf ? 251 : 520,
        [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
            height: isKaf ? 251 : 460
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            height: isKaf ? 233 : 332,
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            height: "100%",
        },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    isKaf && {
        padding: theme.spacing(5),
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            padding: theme.spacing(3),
        },
    },
    !isKaf && systemWidth({ theme }),
    !isKaf && {
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            paddingTop: theme.spacing(7.5),
        },
    },
]);


export const StyledWrapper = styled("div", {
    shouldForwardProp(propName) {
        return propName !== "isKaf";
    },
})<{ isKaf?: boolean }>(({ theme, isKaf }) => [
    {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            flexDirection: "column",
        }
    },
    !isKaf && {
        marginBottom: theme.spacing(7.5),
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            marginBottom: theme.spacing(4),
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            marginBottom: theme.spacing(2),
        },
    },
]);

export const StyledContentWrapper = styled("div")(({ theme }) => ({
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        flexGrow: 2,
    },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(2),
    color: "#ffffff"
}));

export const StyledBadge = styled(Tag)(({ theme }) => ({
    color: "#ffffff",
    borderColor: "#ffffff",
    backgroundColor: "transparent",
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(11),
}));

export const StyledDescription = styled(Truncate)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        color: "#ffffff",
        fontWeight: theme.kaltura.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(16),
        marginBottom: theme.spacing(2),
        width: "100%",
        [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
            width: 642,
        },
        [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
            width: 700,
        },
        [`& .channel-page-desc-more`]: {
            textDecoration: "none",
        },
    },
]);

export const StyledLogo = styled("div")(({ theme }) => ({
    borderRadius: "50%",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    border: "2px solid #ffffff",
    minWidth: 48,
    width: 48,
    height: 48,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        minWidth: 80,
        width: 80,
        height: 80,
        marginRight: theme.spacing(3)
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
        marginBottom: theme.spacing(1),
    }
}));

export const StyledMediaWrapper = styled("div", {
    shouldForwardProp(propName) {
        return propName !== "isKaf";
    },
})<{ isKaf?: boolean }>(({ theme, isKaf }) => ({
    position: "relative",
    marginLeft: theme.spacing(4),
    borderRadius: theme.kaltura.shape.roundness2,
    minWidth: !isKaf ? 419 : 302,
    width: !isKaf ? 419 : 302,
    height: !isKaf ? 237 : 171,
    overflow: "hidden",
    [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
        minWidth: !isKaf ? 379 : 302,
        width: !isKaf ? 379 : 302,
        height: !isKaf ? 214 : 171
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        minWidth: !isKaf ? 390 : 272,
        width: !isKaf ? 390 : 272,
        height: !isKaf ? 220 : 153
    },
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        minWidth: 272,
        width: 272,
        height: 153
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        width: "100%",
        paddingBottom: "56.25%",
        marginLeft: theme.spacing(0),
        marginTop: theme.spacing(2)
    }
}));

export const StyledImage = styled("img")({
    width: "100%",
    borderRadius: 8
});
